import { AddLocationPanel, FixedPricingContextProvider } from "@/components/organisms";

export const AddLocation = () => {
  return (
    <FixedPricingContextProvider>
      <AddLocationPanel />
    </FixedPricingContextProvider>
  );
};
